import { SPATIAL_DATA_SOURCE_CSV, SPATIAL_DATA_SOURCE_LOCATION } from './spatial-data-source.constants';

export const features = {
  GIS: { key: 'gis', description: 'Enables Spatial Analysis functionality', settingsPrefix: 'gis-' },
  MailChimp: { key: 'mailchimp', description: 'Enables MailChimp Integration', settingsPrefix: 'mailchimp-' },
  Zendesk: { key: 'zendesk', description: 'Enables Zendesk Integration', settingsPrefix: 'zendesk-' },
  SpatialDataSourceLocation: {
    key: SPATIAL_DATA_SOURCE_LOCATION,
    description: 'Spatial Analysis: use policy location data only (no CSV / farm table)',
  },
  SpatialDataSourceCsv: {
    key: SPATIAL_DATA_SOURCE_CSV,
    description: 'Spatial Analysis: use imported CSV / farm table only (no policy locations)',
  },
};

export interface Feature {
  key: string;
  description: string;
  settingsPrefix?: string;
}
